import React, { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';
import { getActiveMessagesByType } from '../../../services/ApplicationMessageService';
import './ApplicationMessage.css';

/**
 * ApplicationMessage Component
 * Displays active messages for a specific message type
 * 
 * @param {string} messageType - The type of message to fetch (e.g., 'DEBIT', 'CREDIT', 'maintenance')
 * @param {string} className - Additional CSS classes
 */
const ApplicationMessage = ({ messageType, className = '' }) => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMessages = async () => {
      if (!messageType) {
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        const response = await getActiveMessagesByType(messageType);
        if (response?.data?.success && response?.data?.data) {
          // Sort messages by displayOrder
          const sortedMessages = response.data.data.sort(
            (a, b) => (a.displayOrder || 0) - (b.displayOrder || 0)
          );
          console.log('sortedMessages', sortedMessages);
          setMessages(sortedMessages);
        } else {
          setMessages([]);
        }
      } catch (error) {
        // If 404 or no messages found, silently handle it
        if (error?.response?.status === 404) {
          setMessages([]);
        } else {
          console.error('Error fetching application messages:', error);
          setMessages([]);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, [messageType]);

  // Don't render anything if loading or no messages
  if (loading || messages.length === 0) {
    return null;
  }

  // Get variant based on message type
  const getVariant = (type) => {
    switch (type?.toLowerCase()) {
      case 'debit':
        return 'warning';
      case 'credit':
        return 'warning';
      case 'maintenance':
        return 'warning';
      case 'alert':
        return 'danger';
      default:
        return 'warning';
    }
  };

  return (
    <div className={`application-messages-container ${className}`}>
      {messages.map((msg) => (
        <Alert 
          key={msg.id} 
          variant={getVariant(msg.messageType)}
          className="mb-3 application-message-alert"
        >
          {msg.title && <Alert.Heading className="h6">{msg.title}</Alert.Heading>}
          <p className="mb-0">{msg.message}</p>
        </Alert>
      ))}
    </div>
  );
};

export default ApplicationMessage;
